import type { NewsTranslations } from "../interfaces/news";

export const newsTranslations: NewsTranslations = {
  page_title: "Noticias y anuncios",
  page_subtitle: "Consulta las notas activas y busca por título o descripción.",
  search_placeholder: "Buscar notas, por título, descripción",
  search_aria: "Buscar",
  new_note_button: "Nueva nota",

  error_load: "Error al cargar las notas.",
  error_create: "Error al crear la nota.",
  error_delete: "Error al eliminar la nota.",

  loading_notes: "Cargando notas…",
  searching: "Buscando…",
  empty_search: "No hay notas que coincidan con la búsqueda.",
  empty_no_notes: "No hay notas activas para mostrar.",
  load_more_aria: "Mostrar más notas",
  load_more_loading: "Cargando…",
  load_more: "Mostrar más",

  card_pinned_aria: "Fijada",
  card_delete_aria: "Eliminar nota",
  card_attachments_aria: "Archivos adjuntos",
  card_attachments_section_title: "Archivos adjuntos",
  card_attachments_count: "{{count}} archivo(s)",
  card_attachment_download_title: "Descargar archivo {{n}}",
  card_attachment_download_aria: "Descargar archivo {{n}}",
  card_attachment_download_error: "Error al descargar el archivo.",

  category_WORK_PERMIT: "Permiso de trabajo",
  category_SCHEDULED_MAINTENANCE: "Mantenimiento programado",
  category_INCIDENT: "Incidente",
  category_GENERAL: "General",
  category_REMINDER: "Recordatorio",
  category_URGENT_NOTICE: "Aviso urgente",
  category_PROCESS_CHANGE: "Cambio de proceso",
  category_CLIENT_ISSUE: "Incidencia con cliente",
  category_TRAINING: "Capacitación",
  category_MEETING: "Reunión",

  priority_LOW: "Baja",
  priority_MEDIUM: "Media",
  priority_HIGH: "Alta",
  priority_URGENT: "Urgente",

  modal_new_title: "Nueva nota",
  modal_close_aria: "Cerrar",
  modal_label_title: "Título",
  modal_title_placeholder: "Título de la nota",
  modal_label_content: "Contenido",
  modal_content_placeholder: "Contenido de la nota",
  modal_label_category: "Categoría",
  modal_category_placeholder: "Seleccionar categoría",
  modal_label_priority: "Prioridad",
  modal_priority_placeholder: "Seleccionar prioridad",
  modal_pin_label: "Fijar nota",
  modal_pin_aria: "Fijar nota",
  modal_label_attachments: "Archivos adjuntos (opcional)",
  modal_attachments_description: "PNG, JPG, WebP o PDF hasta 10 MB. Puedes elegir varios archivos.",
  modal_attachments_instruction: "Clic para seleccionar o arrastra archivos aquí",
  modal_cancel: "Cancelar",
  modal_creating: "Creando…",
  modal_create_button: "Crear nota",

  validation_title_required: "El título es obligatorio.",
  validation_title_length: "El título debe tener entre {{min}} y {{max}} caracteres.",
  validation_content_required: "El contenido es obligatorio.",
  validation_category_required: "La categoría es obligatoria.",
  validation_priority_required: "La prioridad es obligatoria.",

  delete_modal_title: "Eliminar nota",
  delete_modal_cancel: "Cancelar",
  delete_modal_confirm: "Eliminar",
  delete_modal_warning: "Esta acción no se puede deshacer.",
  delete_modal_message_with_title:
    "¿Estás seguro de que deseas eliminar la nota «{{title}}»? Esta acción no se puede deshacer.",
  delete_modal_message_no_title:
    "¿Estás seguro de que deseas eliminar esta nota? Esta acción no se puede deshacer.",
};
